import React from 'react';

import { FacebookIcon } from './Icons/FacebookIcon';
import { TwitterIcon } from './Icons/TwitterIcon';
import { LinkedinIcon } from './Icons/LinkedinIcon';
import { CopyLinkIcon } from './Icons/CopyLinkIcon';
import { CopiedIcon } from './Icons/CopiedIcon';
import { withTranslation } from 'react-i18next';
import { createDeepLinkURL } from '../../../../../../actions/utils';
import { CopyUrlButton, IconButton } from 'wix-ui-tpa';
import { SocialBarContainer } from './style';
import { connect } from 'react-redux';
import wixService from '../../../../../../services/wixService';
import triggerEvent from '../../../../../../services/bi/biSiteLogger';
import biData from '../../../../../../services/bi/biEvents.json';

class SocialBar extends React.Component {
  constructor(props) {
    super(props);
    const shownItem = 'shown_' + props.itemId;

    this.state = {
      [shownItem]: false,
      shownName: [shownItem],
      questionURL: '', // on editor does not works
      publicUrl: '',
    };

    createDeepLinkURL(props.itemId, (questionURL) => {
      this.setState({ questionURL });
    });

    this.socialShare = this.socialShare.bind(this);
  }

  socialShare(type, questionURL, question_id, categoryId, question_order) {
    let url = '';
    biData.SHARE_QUESTION = {
      ...biData.SHARE_QUESTION,
      type,
      question_id,
      categoryId,
      question_order,
    };

    triggerEvent(biData.SHARE_QUESTION);

    switch (type) {
      case 'facebook':
        url = 'https://www.facebook.com/sharer/sharer.php?u=';
        break;
      case 'twitter':
        url = 'https://twitter.com/intent/tweet?url=';
        break;
      case 'linkedin':
        url = 'https://www.linkedin.com/shareArticle?mini=true&url=';
        break;
      default:
        url = '';
    }

    if (url !== '') {
      url += questionURL;

      window.open(url, '_blank', 'top=200, left=200, width=700, height=500');
    }
  }
  render() {
    const {
      itemId,
      categoryId,
      question_order,
      shareLink,
      settings,
      t,
      design,
      styleParams,
      isRTL,
    } = this.props;

    const isTwitter = settings.social.twitter;
    const isFacebook = settings.social.facebook;
    const isLinkedin = settings.social.linkedin;
    const isCopyLink = settings.social.copyQuestionLink;
    const isPreview = wixService.isPreviewMode();

    return (
      <>
        {(isFacebook || isTwitter || isLinkedin || isCopyLink) && (
          <SocialBarContainer
            design={design}
            styleParams={styleParams}
            className={isRTL ? 'rtl' : 'ltr'}
          >
            <div className="sprite" />
            <div id={'socialIcons_' + itemId} className="iconList">
              {isFacebook && (
                <IconButton
                  aria-label={t('social.icon.aria.label.facebook')}
                  icon={FacebookIcon({ id: itemId, isPreview, t })}
                  onClick={() => {
                    if (!isPreview) {
                      this.socialShare(
                        'facebook',
                        this.state.questionURL, // shareLink,
                        itemId,
                        categoryId,
                        question_order,
                      );
                    }
                  }}
                  className="facebook"
                />
              )}
              {isTwitter && (
                <IconButton
                  aria-label={t('social.icon.aria.label.twitter')}
                  icon={TwitterIcon({ id: itemId, isPreview, t })}
                  onClick={() => {
                    if (!isPreview) {
                      this.socialShare(
                        'twitter',
                        this.state.questionURL, // shareLink,
                        itemId,
                        categoryId,
                        question_order,
                      );
                    }
                  }}
                  className="twitter"
                />
              )}
              {isLinkedin && (
                <IconButton
                  aria-label={t('social.icon.aria.label.linkedin')}
                  icon={LinkedinIcon({ id: itemId, isPreview, t })}
                  onClick={() => {
                    if (!isPreview) {
                      this.socialShare(
                        'linkedin',
                        this.state.questionURL, // shareLink,
                        itemId,
                        categoryId,
                        question_order,
                      );
                    }
                  }}
                  className="linkedin"
                />
              )}
              {isCopyLink && (
                <section className="copyLink">
                  {!isPreview ? (
                    <CopyUrlButton
                      aria-label={t('copy.tooltip.text')}
                      url={this.state.questionURL} // shareLink
                      tooltipText={t('copy.tooltip.text')}
                      successText={t('copy.success.text')}
                      icon={CopyLinkIcon({ id: itemId })}
                      suffixIcon1={CopiedIcon({ id: itemId })}
                      contentClassName="copyLink"
                    />
                  ) : (
                    <CopyLinkIcon
                      message={t('social.icons.disablePreviewMode')}
                    />
                  )}
                </section>
              )}
            </div>
          </SocialBarContainer>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(SocialBar));
